import Typography from '@material-ui/core/Typography';
import React, { Component } from 'react';
import { Box, CircularProgress, fade } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import axios from 'axios';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import ToggleAnalyticsCard from './ToggleAnalyticsCard';
import CmtCardHeader from '../../../@coremat/CmtCard/CmtCardHeader';
import clsx from 'clsx';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import CmtCard from '../../../@coremat/CmtCard';
import { withRouter } from 'react-router-dom';

const useStyles = theme => ({
  mycard: { padding: 0 },
  mystyle1: {
    flexDirection: 'column',
    minHeight: 250,
    height: '100%',
    display: 'flex',
    padding: 20,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${fade(theme.palette.common.black, 0.12)}`,
    borderRadius: 4,
    textAlign: 'center',

    flexDirection: 'row',
  },
});

class PanelGeneral extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;
    this.state = { data: this.props.data };
    console.log(this.props.data);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
      console.log(this.props.data);
    }
  }

  handleClick() {
    if (this.props.mode == 'arrival') this.props.history.push('/pages/arrivals');
    if (this.props.mode == 'stay') this.props.history.push('/pages/stay');
    if (this.props.mode == 'departure') this.props.history.push('/pages/departures');
    if (this.props.mode == 'bookings') this.props.history.push('/pages/bookingsm');
  }

  render() {
    const { classes } = this.props;
    var mytitle = '',
      mytitle2 = '';
    if (this.props.mode == 'arrival') mytitle = <IntlMessages id="cockpit.arrival" />;
    if (this.props.mode == 'departure') mytitle = <IntlMessages id="cockpit.departure" />;
    if (this.props.mode == 'stay') mytitle = <IntlMessages id="cockpit.stay" />;
    if (this.props.mode == 'bookings') mytitle = <IntlMessages id="cockpit.bookings" />;

    if (this.props.mode == 'arrival') mytitle2 = <IntlMessages id="cockpit.arrived" />;
    if (this.props.mode == 'departure') mytitle2 = <IntlMessages id="cockpit.left" />;
    if (this.props.mode == 'stay') mytitle2 = <IntlMessages id="cockpit.daily" />;
    if (this.props.mode == 'bookings') mytitle2 = <IntlMessages id="cockpit.web" />;

    return (
      <CmtCard>
        <CmtCardContent className={classes.mycard}>
          <Box
            justifyContent="center"
            display="block"
            alignItems="center"
            onClick={() => {
              this.handleClick();
            }}
            component="p"
            color="text.secondary"
            whiteSpace="nowrap"
            fontSize={16}>
            {this.state.data == null && (
              <React.Fragment>
                <CircularProgress size={16} />
              </React.Fragment>
            )}
            {this.state.data != null && (
              <Typography
                component="p"
                style={{ textAlign: 'center', color: this.props.color, fontSize: 'xx-large' }}
                mt={0}>
                {this.state.data.Value1}
              </Typography>
            )}
          </Box>
          <Box
            flexDirection="row"
            alignItems="center"
            component="p"
            color="text.secondary"
            whiteSpace="nowrap"
            justifyContent="center"
            display="block"
            fontSize={14}>
            <Typography component="p" style={{ textAlign: 'center', fontSize: 11 }} mt={0}>
              {mytitle}
            </Typography>
          </Box>
          <Box
            justifyContent="center"
            display="block"
            flexDirection="row"
            alignItems="center"
            component="p"
            color="text.secondary"
            whiteSpace="nowrap"
            fontSize={12}>
            {this.state.data != null && (
              <Typography component="p" style={{ textAlign: 'center', fontSize: 10 }} mt={0}>
                {mytitle2} {this.state.data.Value2}
              </Typography>
            )}
          </Box>
        </CmtCardContent>
      </CmtCard>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(withRouter(PanelGeneral))));
